var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessibilityViolationsSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400.214,
    height: 405.026,
    viewBox: "0 0 400.214 405.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Accessibility_Violations_Sad",
    "data-name": "Accessibility Violations Sad",
    transform: "translate(-654.786 -3498.876)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 183.723,
    cy: 35.506,
    rx: 183.723,
    ry: 35.506,
    transform: "translate(676 3832.891)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18015",
    "data-name": "Group 18015",
    transform: "translate(463 145.649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18014",
    "data-name": "Group 18014",
    transform: "translate(-475.332 -182.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(748.838 3609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_001---Accessibility",
    "data-name": "001---Accessibility",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M55.732,72.464A31.732,31.732,0,1,0,24,40.732,31.732,31.732,0,0,0,55.732,72.464Zm0-52.886A21.155,21.155,0,1,1,34.577,40.732,21.155,21.155,0,0,1,55.732,19.577Z",
    transform: "translate(35.034 -9)",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M177.258,22.05h-.085l-55.531,4.987q-2.84.259-5.685.259H91.249q-2.84,0-5.675-.254L29.948,22.05a15.867,15.867,0,0,0-2.486,31.637l44.885,4.072a5.289,5.289,0,0,1,4.813,5.262V75.185a21.1,21.1,0,0,1-1.46,7.727L50.251,147.724A15.87,15.87,0,0,0,79.275,160.57l24.254-59.3,24.481,59.46c3.651,7.813,32.332-4.814,3.5-77.833a21.144,21.144,0,0,1-1.46-7.716V63.016a5.289,5.289,0,0,1,4.813-5.262l44.811-4.067a15.867,15.867,0,0,0-2.412-31.642Zm1.528,21.112L133.9,47.235a15.787,15.787,0,0,0-14.433,15.787V75.185a31.653,31.653,0,0,0,2.195,11.6c26.874,67.9,16.062,69.768-8.367,10.466a10.487,10.487,0,0,0-19.388,0L69.55,156.392a5.289,5.289,0,1,1-9.52-4.58l25.539-65.05A31.613,31.613,0,0,0,87.737,75.18V63.016A15.787,15.787,0,0,0,73.3,47.219L28.346,43.162a5.3,5.3,0,1,1,.746-10.577l55.531,4.987q3.3.3,6.616.3h24.708q3.316,0,6.616-.3l55.5-4.987a5.3,5.3,0,1,1,.719,10.577Z",
    transform: "translate(-12.838 46.744)",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_12396",
    "data-name": "Path 12396",
    d: "M92.933,337.8a195.37,195.37,0,0,0,75.271,38.4c10.3.653,19.926-4.991,30.257-8.35a10.26,10.26,0,1,0-7.683-19.028,188.271,188.271,0,0,1-19.952,6.821,174.7,174.7,0,0,1-64.82-33.664C37.957,265.639,9.127,156.744,31.353,42.464a233.468,233.468,0,0,0,94.739-2.158A241.8,241.8,0,0,0,170.8,25.094a240.642,240.642,0,0,0,44.764,15.219,233.064,233.064,0,0,0,94.709,2.151,378.133,378.133,0,0,1,3.892,123.58,10.262,10.262,0,0,0,20.323,2.873,401.333,401.333,0,0,0-6.23-140.8,10.263,10.263,0,0,0-12.363-7.79,212.078,212.078,0,0,1-95.671.007A219.387,219.387,0,0,1,175.265,4.518a10.241,10.241,0,0,0-8.889-.007,220.827,220.827,0,0,1-44.941,15.807,212.153,212.153,0,0,1-95.7.013,10.312,10.312,0,0,0-12.363,7.783C-14.186,153.411,17.04,274.967,92.933,337.8Z",
    transform: "translate(193.509 3354.811)",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12397",
    "data-name": "Path 12397",
    d: "M182.279,168.05c44-54.606,3.47-138.69-67.529-138-58.121,2.3-84.6,45.876-84.6,85.386-2.582,64.092,75.82,113.905,137.616,67.127L220.6,235.4a10.261,10.261,0,1,0,14.511-14.512Zm-66.72,12.266c-44.824-1.777-64.886-33.865-64.883-64.883s20.065-63.106,64.479-64.87c85.867,3.417,86.032,126.013.4,129.753Z",
    transform: "translate(348.88 3509.848)",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4622",
    "data-name": "Group 4622",
    transform: "translate(410.783 3597.069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6820",
    "data-name": "Path 6820",
    d: "M183.145,247.119a4.023,4.023,0,0,1-5.682-.314,44.771,44.771,0,0,0-66.441,0,4.024,4.024,0,1,1-6-5.369,52.819,52.819,0,0,1,78.433,0A4.027,4.027,0,0,1,183.145,247.119Z",
    transform: "translate(-91.926 -175.709)",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6821",
    "data-name": "Path 6821",
    d: "M228.122,152.146A20.144,20.144,0,0,1,208,132.024a4.024,4.024,0,0,1,8.048,0,12.073,12.073,0,0,0,24.146,0,4.024,4.024,0,0,1,8.048,0,20.144,20.144,0,0,1-20.121,20.122Z",
    transform: "translate(-143.611 -128)",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6822",
    "data-name": "Path 6822",
    d: "M112.194,132.024a4.024,4.024,0,0,1,8.048,0,20.121,20.121,0,1,1-40.243,0,4.024,4.024,0,0,1,8.049,0,12.073,12.073,0,0,0,24.146,0Z",
    transform: "translate(-80 -128)",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibilityViolationsSad);
export default __webpack_public_path__ + "static/media/accessibility-violations-sad.29b9058522664572c8603c43a5e214ca.svg";
export { ForwardRef as ReactComponent };